import { render, staticRenderFns } from "./comp_AppBar-TopMsg.vue?vue&type=template&id=ede86bac&scoped=true&"
import script from "./comp_AppBar-TopMsg.vue?vue&type=script&lang=js&"
export * from "./comp_AppBar-TopMsg.vue?vue&type=script&lang=js&"
import style0 from "./comp_AppBar-TopMsg.vue?vue&type=style&index=0&id=ede86bac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede86bac",
  null
  
)

export default component.exports